module.exports = __webpack_public_path__ + "939e2b9b115329817009cd5aa839dd22.MP3";